// @ts-check

/** @type {Record<SubscriptionTypeCode, string>} */
export const SubscriptionTypeLabel = {
	free: 'Basic',
	premium: 'Starter',
	pro: 'Pro',
	org: 'Business Light',
	orgFreeTrial: 'Free Trial',
};

/** @enum {typeof SubscriptionMode[keyof typeof SubscriptionMode]} */
export const SubscriptionMode = /** @type {const} */({
	ORGANIZATION: 'ORGANIZATION',
	REGULAR: 'REGULAR',
});

/** @enum {typeof SubscriptionTypeCode[keyof typeof SubscriptionTypeCode]} */
export const SubscriptionTypeCode = /** @type {const} */({
	FREE: 'free',
	PREMIUM: 'premium',
	PRO: 'pro',
	ORGANIZATION: 'org',
	ORGANIZATION_FREE_TRIAL: 'orgFreeTrial',
});

// TODO : type subscription
/**
 * @param {object} subscription
 * @returns {SubscriptionTypeCode}
 */
export const getSubscriptionCode = (subscription) => subscription?.subscriptionType?.code || 'free';

export const getSubscriptionLabel = (subscription) => SubscriptionTypeLabel[
	getSubscriptionCode(subscription)
];

export const getSubscriptionDetails = (subscription) => {
	if (!subscription) return undefined;
	const { organization, regular } = subscription;

	const orgSubType = organization?.subscription?.subscriptionType;

	if (orgSubType?.code === 'org') {
		return orgSubType;
	}

	return regular?.subscription?.subscriptionType;
};

const isOrganizationSubscriptionValid = (organizationSubscription) => (
	!!organizationSubscription?.canAccess
);

const isPaidSubscription = (subscription) => subscription
	&& getSubscriptionCode(subscription) !== SubscriptionTypeCode.FREE;

export const isProAccount = (subscriptions) => {
	if (!subscriptions) return false;
	// Hosts of a valid (paying) organization inherit the org tier, which is
	// Pro-equivalent — same entitlement as an individual Pro account.
	if (isOrganizationSubscriptionValid(subscriptions.organization)) return true;
	if (
		getSubscriptionCode(subscriptions?.regular?.subscription) === SubscriptionTypeCode.PRO
	) return true;
	return false;
};

export const isFreeAccount = (subscriptions) => {
	if (!subscriptions) return true;
	if (isOrganizationSubscriptionValid(subscriptions.organization)) return false;
	if (isPaidSubscription(subscriptions.regular.subscription)) return false;
	return true;
};
